import { schema } from 'normalizr'

const shopReceipt = new schema.Entity('shopReceipts')

export default shopReceipt
